import { FC } from "react";
import { FieldInputProps } from "react-final-form";
import { useSelector } from "react-redux";

import { Warning } from "@livechat/design-system-icons";
import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { mapTagsToOptionsWithGrouping } from "helpers/tags";
import { IRuleActionAddTags, IRuleActionRemoveTags } from "store/entities/rules/interfaces";
import { selectTagsAlphabetically } from "store/entities/tags";
import { selectTeamsAlphabetically } from "store/entities/teams";

import { changeActionValues } from "../utils";

interface IProps {
  input: FieldInputProps<IRuleActionAddTags | IRuleActionRemoveTags>;
}

export const Tag: FC<IProps> = ({ input }) => {
  const tags = useSelector(selectTagsAlphabetically);
  const teams = useSelector(selectTeamsAlphabetically);

  const options = mapTagsToOptionsWithGrouping(tags, teams);

  const selected = input.value.tagIDs.map(id => options.find(opt => opt.key === id) ?? createDeletedTag(id));

  const onSelect = (selected: IPickerListItem[] | null): void => {
    changeActionValues(input, { tagIDs: selected?.map(s => s.key) ?? [] });
  };

  return (
    <Picker
      options={options}
      onSelect={onSelect}
      type="multi"
      selected={selected}
      placeholder="Select one tag or more…"
      hideClearButton
      data-testid="tags-picker"
    />
  );
};

const createDeletedTag = (id: string): IPickerListItem => ({
  key: id,
  name: "Tag removed",
  icon: Warning,
  selectedTagOptions: {
    kind: "error",
  },
});
